module.exports = __webpack_public_path__ + "img/vehicle_3.4e582e55.svg";